import React from 'react';
import BaseContainer from "../BaseContainer";
import H1 from '../Headings/H1';
import H4 from '../Headings/H4';

const PageNotFound = ({ data }) => {
    const { title = '', subtitle = '', description = '', helpfulLinksTitle = '', helpfulLinks = [], desktopImage, mobileImage } = data;

    return (
        <BaseContainer className='mt-[84px] lg:mt-[224px] mb-[40px] lg:mb-[80px]'>
            <div className="flex flex-col lg:flex-row w-full">
                {/* Left Section - Text Content */}
                <div className="w-full lg:w-1/2 flex flex-col items-center lg:items-start lg:pr-14">
                    {title && title !== "" && (
                        <div className="mb-4 text-xs font-bold text-ek-red tracking-[4.8px]">
                            {title}
                        </div>
                    )}

                    {subtitle && subtitle !== "" && (
                        <H1 className="mb-4 font-medium">{subtitle}</H1>
                    )}

                    {/* Mobile Image */}
                    {mobileImage && (
                        <div className="mb-4 w-full lg:hidden">
                            <img src={mobileImage} alt="Mobile" className="w-full h-full object-contain" />
                        </div>
                    )}

                    {description && description !== "" && (
                        <div
                            className="text-ek-grey-500 tracking-[0.64px] mb-4 lg:mb-8"
                            dangerouslySetInnerHTML={{ __html: description }}
                        ></div>
                    )}

                    {helpfulLinks.length > 0 && (
                        <div className='w-full'>
                            {helpfulLinksTitle && <H4 className="mb-2 lg:mb-3">{helpfulLinksTitle}</H4>}
                            <ul>
                                {helpfulLinks.map((link, index) => (
                                    <li key={index} className="list-none mb-4 lg:mb-3">
                                        <a
                                            href={link.url}
                                            target={link.target || "_self"}
                                            rel={link.target === "_blank" ? "noopener noreferrer" : undefined}
                                            className="text-sm lg:text-base tracking-wider text-ek-red hover:text-ek-red-200 active:text-ek-red-300 underline font-medium"
                                        >
                                            {link.title}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>

                {/* Right Section - Desktop Image */}
                {desktopImage && (
                    <div className="hidden lg:block w-full lg:w-1/2">
                        <img src={desktopImage} alt="Desktop" className="w-full h-full object-contain" />
                    </div>
                )}
            </div>

        </BaseContainer>
    )
}

export default PageNotFound;